import PropTypes from "prop-types"
import React, { useEffect, useState } from "react";
import { Row, Col, CardBody, Card, Container, Form, Input, FormFeedback, Button } from "reactstrap";
import { addNewUser } from "../../store/catalogs/Users/actions"
import { Operativeroles, userTypes, Offsymbol, OnSymbol, techAdvisorRoles } from '../../constants/holcim'
import { getLocations } from "../../store/catalogs/Locations/actions"
import { getLabTypes } from "../../store/catalogs/LabTypes/actions"
import Switch from "react-switch"
import Footer from '../../components/Common/Footer'

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

// action
import { apiError } from "../../store/actions"

// Redux
import { useSelector, useDispatch, shallowEqual } from "react-redux";

import { withRouter, Link } from "react-router-dom";


// import images
import logolight from "../../assets/images/holcimlogoAdipi.png"


const Register = props => {
  const dispatch = useDispatch();

  const [active, setActive] = useState(false);
  const lockActive = true;
  const [isOperative, setOperativeForm] = useState(false);
  const [isAdviser, setAdviserForm] = useState(false);
  const [selectValue, setSelectValue] = useState(undefined)

  const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/
  const passworkRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/



  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
        name: '',
        surname: '',
        phone: '',
        email: '',
        password: '',
        laboratoryType: '',
        location: '',
        userType: selectValue,
        role: selectValue === 'Asesor Técnico' ? 'Asesor Técnico': (selectValue === 'Operativo') ? 'Laboratorista': '',
        signature: '',
        address: '',
        isGoogled: '',
    },
    validationSchema: Yup.object({
        name: Yup.string().required("Ingrese el nombre del usuario"),
        surname: Yup.string().required("Ingrese el appellido del usuario"),
        phone: Yup.string().matches(phoneRegExp, 'Número telefónico inválido').required('El nùmero telefónico es un campo requerido'),
        email: Yup.string().email('Ingrese un correo electrónico válido').required('Ingrese el correo electrónico'),
        password: Yup.string().matches(passworkRegex, 'La contraseña debe incluir al menos 8 caracteres, 1 minúscula, 1 mayúscula y 1 número').required('La contraseña es un campo requerido'),
        laboratoryType: Yup.string().required("Seleccione tipo de laboratorio"),
        location: Yup.string().required("Seleccione ubicación"),
        userType: Yup.string().required("Seleccione tipo de usuario"),
        role: Yup.string().required("Seleccione un rol"),
        signature: Yup.string().required("Ingrese firma"),
        address: Yup.string().required("Ingrese dirección"),
    }),
    onSubmit: (values, { resetForm }) => {
        dispatch(addNewUser(values))
        resetForm()
    }
});

  const { locations, labtypes } = useSelector(state => ({
    locations: state.locations.locations,
    labtypes: state.labType.labtypes,
  }), shallowEqual);


  // handleValidSubmit
  // const handleValidSubmit = (event, values) => {
  //   dispatch(registerUser(values));
  // }

  useEffect(() => {
    dispatch(apiError(""));
    dispatch(getLabTypes(`?limit=1000&page=0`))
    dispatch(getLocations(`?limit=1000&page=0`))
    document.body.className = "authentication-bg";
    // remove classname when component will unmount
    return function cleanup() {
      document.body.className = "";
    };
  }, [dispatch]);

  return (

    <React.Fragment>
      <div className="account-pages my-5 pt-sm-3">
        <Container>
          <Row className="align-items-center justify-content-center">
            <Col md={2} lg={6} xl={15}>
              <Card>
                <CardBody className="p-4">
                  <div className="text-center">
                    <Link to="/" className="d-block auth-logo">
                      <img src={logolight} alt="" height="52" className="logo logo-dark" />
                    </Link>
                  </div>
                  <div className="text-center mt-3">
                    <strong><h3 className="text-primary">DiPi - Digital Platform of Innovation</h3></strong>
                    <h4 className="text-center mt-4">Crea una cuenta</h4>
                  </div>
                  <label className="col-md-12 col-form-label">Seleccionar tipo de Usuario</label>
                  <div className="col-md-12">
                    <select
                      value={selectValue}
                      onChange={(event) => {
                        setSelectValue(event.target.value)
                        if (event.target.value === 'Operativo') {
                          setAdviserForm(false)
                          setOperativeForm(true)
                        } else if (event.target.value === 'Asesor Técnico') {
                          setAdviserForm(true)
                          setOperativeForm(false)
                        }
                        else {
                          setAdviserForm(false)
                          setOperativeForm(false)
                        }
                      }}
                      placeholder="Seleccione tipo de usuario"
                      className="form-control">
                      <option>-</option>
                      <option>Operativo</option>
                      <option>Asesor Técnico</option>
                    </select>
                  </div>
                  <div className="p-2 mt-4">
                    {
                      (isAdviser || isOperative) ?
                        <Form
                        className="form-horizontal mt-1 mb-1"
                        onSubmit={(e) => {
                            e.preventDefault();
                            validation.handleSubmit();
                            return false;
                        }}
                      >
                        <div className="mb-3 ">
                            <label className='text-primary'>Nombre de Usuario</label>
                            <Input
                                name="name"
                                className="form-control text-primary"
                                placeholder="Nombre"
                                type="text"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.name || ""}
                                invalid={
                                    validation.touched.name && validation.errors.name ? true : false
                                }
                            />
                            {validation.touched.name && validation.errors.name ? (
                                <FormFeedback type="invalid">{validation.errors.name}</FormFeedback>
                            ) : null}
                        </div>
                        <div className="mb-3 ">
                            <label className='text-primary'>Apellido</label>
                            <Input
                                name="surname"
                                className="form-control text-primary"
                                placeholder="Apellido"
                                type="text"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.surname || ""}
                                invalid={
                                    validation.touched.surname && validation.errors.surname ? true : false
                                }
                            />
                            {validation.touched.surname && validation.errors.surname ? (
                                <FormFeedback type="invalid">{validation.errors.surname}</FormFeedback>
                            ) : null}
                        </div>
                        <div className="mb-3 ">
                            <label className='text-primary'>Correo Electrónico</label>
                            <Input
                                name="email"
                                className="form-control text-primary"
                                placeholder="Correo Electrónico"
                                type="text"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.email || ""}
                                invalid={
                                    validation.touched.email && validation.errors.email ? true : false
                                }
                            />
                            {validation.touched.email && validation.errors.email ? (
                                <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
                            ) : null}
                        </div>
                        <div className="mb-3 ">
                            <label className='text-primary'>Domicilio</label>
                            <Input
                                name="address"
                                className="form-control text-primary"
                                placeholder="Domicilio"
                                type="text"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.address || ""}
                                invalid={
                                    validation.touched.address && validation.errors.address ? true : false
                                }
                            />
                            {validation.touched.address && validation.errors.address ? (
                                <FormFeedback type="invalid">{validation.errors.address}</FormFeedback>
                            ) : null}
                        </div>
                        <div className="mb-3 ">
                            <label className='text-primary'>Teléfono</label>
                            <Input
                                name="phone"
                                className="form-control text-primary"
                                placeholder="Teléfono"
                                type="text"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.phone || ""}
                                invalid={
                                    validation.touched.phone && validation.errors.phone ? true : false
                                }
                            />
                            {validation.touched.phone && validation.errors.phone ? (
                                <FormFeedback type="invalid">{validation.errors.phone}</FormFeedback>
                            ) : null}
                        </div>
                        <div className="mb-3 ">
                            <label className='text-primary'>Contraseña</label>
                            <Input
                                name="password"
                                value={validation.values.password || ""}
                                type="password"
                                placeholder="Ingrese contraseña"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                invalid={
                                    validation.touched.password && validation.errors.password ? true : false
                                }
                            />
                            {validation.touched.password && validation.errors.password ? (
                                <FormFeedback type="invalid">{validation.errors.password}</FormFeedback>
                            ) : null}
                        </div>
                        <div className="mb-3 ">
                            <label className='text-primary'>Tipo de Laboratorio</label>
                            <select
                                required
                                defaultValue=""
                                name="laboratoryType"
                                className="form-select text-primary"
                                placeholder="Tipo de Laboratorio"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.laboratoryType || ""}
                            >
                                <option value="">Seleccione Tipo de Laboratorio</option>
                                {labtypes.map((dir, index) => {
                                    return <option key={index} value={dir.id}>{dir.name}</option>
                                })}
                            </select>
                        </div>
                        <div className="mb-3 ">
                            <label className='text-primary'>Ubicación</label>
                            <select
                                required
                                defaultValue=""
                                name="location"
                                className="form-select text-primary"
                                placeholder="Tipo de Laboratorio"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.location || ""}
                            >
                                <option value="">Seleccione Ubicación</option>
                                {locations.map((dir, index) => {
                                    return <option key={index} value={dir.id}>{dir.name}</option>
                                })}
                            </select>
                        </div>
                        <div className="mb-3 ">
                            <label className='text-primary'>Tipo de Usuario</label>
                            <select
                                required
                                disabled
                                defaultValue=""
                                name="userType"
                                className="form-select text-primary"
                                placeholder="Tipo de Usuario"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.userType || ""}
                            >
                                <option value="">Seleccione Tipo de Usuario</option>
                                {userTypes.map((dir, index) => {
                                    return <option key={index} value={dir.value}>{dir.value}</option>
                                })}
                            </select>
                        </div>
                        <div className="mb-3 ">
                            <label className='text-primary'>Roles</label>
                            <select
                                required
                                disabled
                                defaultValue=""
                                name="role"
                                className="form-select text-primary"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.role || ""}
                            >
                                <option value="">Seleccione Rol</option>
                                {
                                  isAdviser ? 
                                  techAdvisorRoles.map((dir, index) => {
                                    return <option key={index} value={dir.value}>{dir.value}</option>
                                  }) :
                                  Operativeroles.map((dir, index) => {
                                    return <option key={index} value={dir.value}>{dir.value}</option>
                                  })
                                }
                            </select>
                        </div>
                        <div className="mb-3 ">
                            <label className='text-primary'>Firma</label>
                            <Input
                                name="signature"
                                className="form-control text-primary"
                                placeholder="Firma"
                                type="text"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.signature || ""}
                                invalid={
                                    validation.touched.signature && validation.errors.signature ? true : false
                                }
                            />
                            {validation.touched.signature && validation.errors.signature ? (
                                <FormFeedback type="invalid">{validation.errors.signature}</FormFeedback>
                            ) : null}
                        </div>
                        <div className="mt-2 ">
                            <div className='text-primary pb-2'>Autenticación por Google?</div>
                            <Switch
                                // name='recordStatus'
                                // disabled={lockActive}
                                className='me-4'
                                name='isGoogled'
                                uncheckedIcon={<Offsymbol />}
                                checkedIcon={<OnSymbol />}
                                onColor="#94C12E"
                                // type="check" // TODO:
                                // onClick={() => { setActive(!active) }}
                                // onChange={validation.handleChange}
                                // onBlur={validation.handleBlur}
                                // value={validation.values.recordStatus || active}
                                // onChange={() => { setActive(!active) }}
                                // checked={active}
                                onChange={(value1) => {
                                    // validation.values.isGoogled = value1
                                    validation.setFieldValue('isGoogled', value1)
                                }}
                                
                                onBlur={validation.handleBlur}
                                checked={validation.values.isGoogled || ""}
                            />
                        </div>
                        <div className="mt-2 ">
                            <div className='text-primary pb-2'>Activo</div>
                            <Switch
                                // name='recordStatus'
                                disabled={lockActive}
                                className='me-4'
                                uncheckedIcon={<Offsymbol />}
                                checkedIcon={<OnSymbol />}
                                onColor="#94C12E"
                                // type="check" // TODO:
                                // onClick={() => { setActive(!active) }}
                                // onChange={validation.handleChange}
                                // onBlur={validation.handleBlur}
                                // value={validation.values.recordStatus || active}
                                onChange={() => { setActive(!active) }}
                                checked={active}
                            />
                        </div>
    
                        <div className='mt-5'>
                            <hr style={{ background: 'linear-gradient(to right, #94C12E,#04BBF1 ,#1D4370)', height: 4 }} />
                            <div className="page-title-box d-flex justify-content-end">
                                <Button type="submit" outline color="primary" className='rounded-3 me-4' >
                                    <span className="mdi mdi-content-save me-1"></span>Registrar
                                </Button>
                            </div>
                        </div>
                        <div className="mt-3">
                              <Link to="/login" className="d-block auth-logo">
                                <button
                                  className="btn btn-primary w-100 rounded-4"
                                >
                                  <span className="mdi mdi-keyboard-backspace me-2"></span>
                                  Iniciar sesión
                                </button>
                              </Link>
                            </div>
                    </Form>
                       :

                          <>
                            {/* <div className="mt-4">
                              <button
                                className="btn btn-primary w-100 rounded-4"
                              >
                                <span className="mdi mdi-account-plus me-2"></span>
                                Registrar
                              </button>
                            </div> */}

                            <div className="mt-3">
                              <Link to="/login" className="d-block auth-logo">
                                <button
                                  className="btn btn-primary w-100 rounded-4"
                                >
                                  <span className="mdi mdi-keyboard-backspace me-2"></span>
                                  Iniciar sesión
                                </button>
                              </Link>
                            </div>
                          </>
                    }

                  </div>
                </CardBody>
              </Card>
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
            </Col>
          </Row>
        </Container>
        <Footer />
      </div>
    </React.Fragment>
  )
}
export default withRouter(Register);

Register.propTypes = {
  registerUser: PropTypes.func,
  // registerUserFailed: PropTypes.func,
  registrationError: PropTypes.any,
  user: PropTypes.any,
}



